module.exports = __webpack_public_path__ + "static/media/rating.b493ce83.png";